import { useState, useCallback } from 'react';
import { FormularioCampo } from '@/types/formulario';

export function useFormularioBuilder() {
  const [selectedCampoId, setSelectedCampoId] = useState<string | null>(null);
  const [previewMode, setPreviewMode] = useState(false);

  const togglePreviewMode = useCallback(() => {
    setPreviewMode(prev => !prev);
  }, []);

  const selectCampo = useCallback((campoId: string | null) => {
    setSelectedCampoId(campoId);
  }, []);

  const clearSelection = useCallback(() => {
    setSelectedCampoId(null);
  }, []);

  return {
    selectedCampoId,
    previewMode,
    togglePreviewMode,
    selectCampo,
    clearSelection,
  };
}
